import { BaseWorkflowStep } from "./BaseWorkflowStep";

abstract class CancellableWorkflowStep<T> extends BaseWorkflowStep<T> {
    public constructor(stepEnum: T) {
        super(stepEnum);
    }

    public abstract cancel(): void;
}

export { CancellableWorkflowStep };
